import axios from "axios";
import { Component } from "react";
import GeneralBloc from "../bloc/general_bloc";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";

export default class ClientWebServices extends Component {
    static async verifyIDNumber(payload) {
        let header = await BaseWebService.normalHeaders();
        let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/verifyIdNo`);
        try {
            let resp = await axios.post(
                url,
                payload,
                { headers: header }
            );
            let response = BaseWebService.standardResponseFromWeb(resp.data);
            return response;
        } catch (error) {
            return error;
        }

    }

    static async requestOTP(payload) {
        let header = await BaseWebService.normalHeaders();
        try {
            let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/requestSendOtp`);
            let resp = await axios.post(
                url,
                payload,
                { headers: header }
            );
            let response = BaseWebService.standardResponseFromWeb(resp.data);
            return response;
        } catch (error) {
            return error;
        }
    }

    static async verifyOTP(payload) {
        let header = await BaseWebService.normalHeaders();
        try {
            let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/verifyOtp`);
            let resp = await axios.post(
                url,
                payload,
                { headers: header }
            );
            let response = BaseWebService.standardResponseFromWeb(resp.data);
            return response;
        } catch (error) {
            return error;
        }
    }

    static async getReviewDetails(proposalId) {
        let header = await BaseWebService.normalHeaders();
        try {
            let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/quoAndProposalDetailsForClientReview?proposalId=${proposalId}`);
            let resp = await axios.get(
                url,
                { headers: header }
            );
            let response = BaseWebService.standardResponseFromWeb(resp.data);
            return response;
        } catch (error) {
            return error;
        }
    }

    static async getUploadedDocument(proposalId, docId) {
        let header = await BaseWebService.normalHeaders();
        try {
            let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/fetchUploadedDocContentForClientReview?proposalId=${proposalId}&uploadedDocId=${docId}`);
            let resp = await axios.get(
                url,
                { headers: header }
            );
            let response = BaseWebService.standardResponseFromWeb(resp.data);
            return response;
        } catch (error) {
            return error;
        }
    }

    static async submitSignature(id, payload) {
        let header = await BaseWebService.normalHeaders();
        try {
            let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/proposal/submitSignature?proposalId=${id}`);
            let resp = await axios.post(
                url,
                payload,
                { headers: header }
            );
            let response = BaseWebService.standardResponseFromWeb(resp.data);
            return response;
        } catch (error) {
            return error;
        }
    }
}